/** @file Dopesheet canvas metrics in CSS pixels: ruler band, row height, key sizes, minimum label spacing. */

/** Sizes the drawing, the pointer handling and the row headers share. */
export const DOPE_PX = {
  /** Height of the frame ruler band at the top of the canvas. */
  ruler: 22,
  /** Row height (the row headers use the same). */
  row: 20,
  /** Half-diagonal of a channel key diamond. */
  key: 4,
  /** Half-diagonal of a group (summary) key diamond. */
  groupKey: 5,
  /** Least spacing between two ruler labels. */
  label: 48,
} as const;
